import { render, staticRenderFns } from "./Agent_journey.vue?vue&type=template&id=5e4edfe8&scoped=true&"
import script from "./Agent_journey.vue?vue&type=script&lang=js&"
export * from "./Agent_journey.vue?vue&type=script&lang=js&"
import style0 from "./Agent_journey.vue?vue&type=style&index=0&id=5e4edfe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4edfe8",
  null
  
)

export default component.exports